import React from "react"
import { compose, withProps } from "recompose"
import { withScriptjs, withGoogleMap, GoogleMap, Marker } from "react-google-maps"
import {API_KEY} from '../../utils/constants'

export default compose(
  withProps({
    googleMapURL: `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&language=en&v=3.exp&libraries=geometry,drawing,places`,
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ flexGrow: 1, minHeight: '400px' }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)(({
  onMapClick,
  onMarkerClick,
  address
}) => {
  const defaultCenter = address
    ? {lat: address.lat, lng: address.lng}
    : {lat: 33.7502588, lng: -84.3864037}
  return (
    <GoogleMap
      defaultZoom={18}
      defaultCenter={defaultCenter}
      onClick={onMapClick}
      options={{
        draggableCursor: 'default',
        draggingCursor: 'move'
      }}
    >
      {address && <Marker position={address} onClick={onMarkerClick} />}
    </GoogleMap>
  );
}
);